import React from 'react';

import { Anchor, Spacer } from '@zillow/constellation';

import { StyledErrorText } from 'app/shared/components/Wizard/PhoneVerificationWizard/StyledComponents';

const MaxAttemptsError = () => (
    <Spacer marginTop="sm">
        <StyledErrorText
            as="div"
            fontType="bodySmall"
        >
            You have exceeded the maximum verification attempts for this number.
            {' Please provide a different phone number or '}
            <Anchor
                target="_blank"
                href="https://help.zillowrentalmanager.com/hc/en-us/requests/new"
            >
                contact customer support.
            </Anchor>
        </StyledErrorText>
    </Spacer>
);

export default MaxAttemptsError;
